/* eslint-disable max-lines */
import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      personnel: {
         academicTitle: 'Tytuł naukowy',
         addWorkingTime: 'Dodaj czas pracy',
         address: {
            address: 'Adres zamieszkania',
            includeAddress: 'Chcę dodać adres',
            optionalAddressForPrescriptionsProAuctore:
               'Opcjonalne, potrzebne do wysyłki recept pro auctore i pro familia.',
         },
         allOptions: 'Wszystkie opcje',
         availability: {
            create: {
               form: {
                  errors: {
                     fetchData: 'Wystąpił błąd pobierania danych na potrzeby tworzenia dostępności.',
                  },
               },
            },
            update: {
               form: {
                  errors: {
                     fetchData: 'Wystąpił błąd pobierania danych na potrzeby aktualizacji dostępności.',
                  },
               },
            },
         },
         availabilityShorterThanVisitTime: 'Wizyta nie może być dłuższa niż zadeklarowany czas pracy.',
         certificateFault: {
            authenticationRequired: 'Przeloguj się w celu ponownego uwierzytelnienia.',
            certificateNoLongerValid:
               'Nieprawidłowy certyfikat osobisty. Zaktualizuj go w zakładce "Moje konto" i ponów próbę.',
            invalidPersonalCertificatePrivateKey:
               'Nieprawidłowy certyfikat osobisty. Wgraj go ponownie w zakładce "Moje konto".',
            noValidPersonalCertificate: 'Brak ważnego certyfikatu. Wgraj go w zakładce "Moje konto".',
         },
         choose: 'Wybierz',
         chosenServices: 'Wybrano {{selectedCount}} {{servicesTranslation}}',
         chosenServicesSuffixAccusative: 'usługę',
         chosenServicesSuffixGenitive: 'usługi',
         chosenServicesSuffixPlural: 'usług',
         concernsOnlySelectedAvailability: 'Dotyczy tylko wybranej daty',
         confirmRemovingSelectedAvailability: 'Czy na pewno chcesz usunąć wybraną dostępność?',
         confirmRemovingSelectedRecurringAvailabilityIfAppointmentInRange:
            'W zakresie dostępności, którą chcesz usunąć zarezerwowano już wizyty w przyszłości (np. w dniu {{appointmentDateInUpdatedAvailabilityDateRange}}). Czy chcesz usunąć dostępność mimo to?',
         confirmRemovingSelectedSingleAvailabilityIfAppointmentInRange:
            'W zakresie dostępności, którą chcesz usunąć zarezerwowano już wizyty. Czy chcesz usunąć dostępność mimo to?',
         confirmUpdateSelectedRecurringAvailabilityIfAppointmentInRange:
            'W zakresie dostępności, którą modyfikujesz zarezerwowano już wizyty w przyszłości (np. w dniu {{appointmentDateInUpdatedAvailabilityDateRange}}). Czy chcesz zmodyfikować dostępność mimo to?',
         confirmUpdateSelectedSingleAvailabilityIfAppointmentInRange:
            'W zakresie dostępności, którą modyfikujesz zarezerwowano już wizyty. Czy chcesz zmodyfikować dostępność mimo to?',
         doNotRepeat: 'Nie powtarzaj',
         docplannerIntegrationSettings: 'ustawieniach integracji',
         docplannerServicesInformationForAdmin:
            'Do portalu Znany Lekarz zostaną przekazane tylko powiązane usługi w <docplannerIntegrationSettingsLink />.',
         docplannerServicesInformationForNonAdmin:
            'Do portalu Znany Lekarz zostaną przekazane tylko powiązane przez administratora usługi w ustawieniach integracji.',
         doctorFetchErrorPractice: 'Nie udało się pobrać danych użytkownika. Spróbuj ponownie później.',
         doctorsFetchErrorOrganization: 'Nie udało się pobrać listy użytkowników. Spróbuj ponownie później.',
         eRegistrationRequiresSlotDivision: 'Rejestracja online wymaga podziału na wizyty.',
         encounterModeLabel: 'Terminy na wizyty',
         encounterModeMap: {
            onSite: 'stacjonarne',
            videoConsultation: 'online',
         },
         everyTwoWeeks: 'Co 2 tygodnie',
         everyWeek: 'Co 1 tydzień',
         fillDurationOrChooseOtherOption: 'Uzupełnij czas trwania wizyty lub wybierz inną opcję z listy.',
         fromHour: 'od',
         healthcareProviderLocation: 'Miejsce Udzielania Świadczeń',
         identificationType: {
            MEDICAL_LICENCE_NUMBER: 'NPWZ',
            PESEL: 'PESEL',
         },
         incorrectPastDateForRecurringAvailability:
            'Dostępność cykliczna nie może być utworzona w terminie przed bieżącym tygodniem.',
         incorrectPastDateForRecurringAvailabilityUpdate:
            'Dostępność cykliczna nie może być edytowana w terminie przed bieżącym tygodniem.',
         incorrectPastDateForSingleAvailability:
            'Dostępność jednorazowa nie może być utworzona w terminie w przeszłości.',
         incorrectPastDateForSingleAvailabilityUpdate:
            'Dostępność jednorazowa nie może być edytowana w terminie w przeszłości.',
         incorrectScheduleTimeRange: 'Godzina zakończenia dostępności musi być późniejsza niż godzina rozpoczęcia',
         incorrectSlotDuration: 'Wymagana wielokrotność liczby 5 z zakresu od 5 do 120 min.',
         medicalLicenceNumberLabel: 'Numer PWZ (7 cyfr)',
         myAccount: {
            certificate: {
               certificate: 'Certyfikat osobisty',
               certificateLoading: 'Wczytuję dane certyfikatu',
               createCertificateSuccess: 'Certyfikat został pomyślnie stworzony.',
               errorOccurredWhileEnteringCertificate: 'Podczas wprowadzania certyfikatu wystąpił błąd.',
               fileUploadPlaceholder: 'Wybierz plik z rozszerzeniem .p12 lub .pfx',
               form: {
                  add: 'Dodaj certyfikat ZUS',
                  authenticate: 'Uwierzytelnienie zmiany',
                  change: 'Zmiana certyfikatu',
                  choose: 'Wybierz certyfikat',
                  chooseCertificateFile: 'Wskaż plik certyfikatu',
                  current: 'Aktualny certyfikat',
                  email: 'E-mail',
                  fileExtensions: 'Dodaj plik certyfikatu z rozszerzeniem .p12 lub .pfx',
                  invalidExtension: 'Dodaj plik certyfikatu z rozszerzeniem .p12 lub .pfx',
                  leavingPrompt: {
                     message: 'Istnieją niezapisane dane dla konta.\nCzy na pewno chcesz wyjść i utracić te dane?',
                     title: 'Wyjdź z edycji konta',
                  },
                  password: 'Hasło do konta',
                  save: 'Zapisz certyfikat',
                  submitError: 'Wystąpił błąd podczas wysyłania formularza. Sprawdź poprawność wprowadzonych danych',
               },
               incorrectCertificate: 'Certyfikat jest niepoprawny',
               incorrectCertificateValidity: 'Certyfikat jest nieważny',
               incorrectPassword: 'Hasło nie pasuje do dodanego certyfikatu',
               incorrectPersonalPassword: 'Niepoprawne hasło',
               issuedFor: 'Wystawiony dla: <bold>{{certificateName}}, serialNumber={{serialNumber}}</bold>',
               noValidCertificate: 'Brak ważnego certyfikatu',
               unavailableInDemo: 'Niedostępne w wersji demo',
               updateCertificateSuccess: 'Certyfikat został pomyślnie zapisany.',
               validTo: 'Ważny do: <bold>{{validTo}}</bold>',
               youHaveCertificate: 'Posiadasz certyfikat',
            },
            header: 'Moje konto',
            loginSettings: 'Ustawienia logowania',
            mfaSettings: {
               accountName: 'Nazwa konta',
               areYouSureRemovingAssociation:
                  'Czy na pewno chcesz wyłączyć powiązanie z aplikacją do logowania dwuetapowego?',
               associate: 'Powiąż',
               associationDate: 'Data powiązania',
               associationDateDescription: '<associationDate />: {{associationDate}}',
               associationRemovedSuccessfully: 'Powiązanie zostało wyłączone.',
               enterVerificationCodeFromAuthenticatorApp:
                  'Następnie w aplikacji do uwierzytelnienia pokaże się kod potwierdzający, należy go wprowadzić poniżej.',
               failedToFetchMfaInfo: 'Nie udało się pobrać klucza bezpieczeństwa. Spróbuj ponownie.',
               failedToFetchMfaSettings: 'Nie udało się pobrać ustawień logowania dwuetapowego. Spróbuj ponownie.',
               mfaHasBeenActivated: 'Weryfikacja dwuetapowa została włączona.',
               mfaInfo:
                  'Do logowania dwuetapowego potrzebujemy powiązania z aplikacją do uwierzytelnienia generującej tzw. token TOTP, np. Microsoft Authenticator lub Google Authenticator. Aby dodać konto do takiej aplikacji skanujemy kod QR bezpośrednio z aplikacji lub przepisujemy poniższe informacje ręcznie.',
               mfaSettingsWithTOTP: 'Ustawienia logowania dwuetapowego (MFA z tokenem TOTP)',
               removeAssociation: 'Wyłącz powiązanie',
               secret: 'Klucz bezpieczeństwa (sekret)',
               trustedDeviceTable: {
                  addTrustedDeviceDuringLogIn: 'Zapisz bezpieczne urządzenie podczas logowania do eGabinetu.',
                  areYouSureRemovingTrustedDevice:
                     'Czy na pewno chcesz usunąć urządzenie <deviceName /> z listy zaufanych?',
                  deviceName: 'Nazwa urządzenia',
                  deviceRemovedSuccessfully: 'Urządzenie zaufane zostało usunięte',
                  lastLoginDate: 'Data ostatniego logowania',
                  noDevicesAdded: 'Nie dodano żadnego urządzenia bezpiecznego',
                  ordinalNumber: 'Lp.',
                  remove: 'Usuń',
                  trustedDevicesFetchError: 'Nie udało się pobrać listy urządzeń zaufanych. Spróbuj ponownie.',
                  trustedDevicesList: 'Lista urządzeń, które są uznawane za bezpieczne.',
                  youAreRemovingTrustedDevice: 'Usuwasz zaufane urządzenie',
               },
               turnOff: 'Wyłącz',
               verificationCode: 'Kod hasła jednorazowego',
               verificationCodeValidation: 'Kod musi mieć dokładnie 6 cyfr.',
               youAreRemovingAssociation: 'Wyłączasz powiązanie',
               yourAccountIsAssociated: 'Twoje konto jest powiązane z aplikacją logowania dwuetapowego.',
            },
            nfz: {
               nfzConfiguration: 'Ustawienia NFZ',
            },
            password: {
               changePassword: 'Zmiana hasła',
               doNotEnforcePasswordChange: 'Nie wymuszaj zmiany hasła co 30 dni',
               incorrectOldPassword: 'Niepoprawne stare hasło',
               loadingPasswordSettings: 'Wczytywanie ustawień hasła',
               newPassword: 'Nowe hasło',
               oldPassword: 'Stare hasło',
               passwordIsNotDifferent: 'Nowe hasło nie może być takie samo jak stare',
               passwordNotMatchingRestrictions:
                  'Nowe hasło musi składać się z co najmniej 8 znaków, zawierać małe i wielkie litery oraz cyfry lub znaki specjalne',
               passwordUpdateEnforcedEveryThirtyDays: 'Zmiana hasła będzie wymuszana co 30 dni.',
               passwordUpdateNotEnforced: 'Zmiana hasła nie będzie wymuszana.',
               passwordUpdated: 'Hasło zostało zmienione.',
               passwordsAreDifferent: 'Podane hasła są różne',
               repeatNewPassword: 'Powtórz nowe hasło',
               updateSystemPassword: 'Zmień swoje hasło',
            },
            personalData: {
               contactNumber: 'Numer kontaktowy',
               failedToFetchPersonalData: 'Nie powiodło się pobranie danych osobowych.',
               incorrectPhoneNumber: 'Numer telefonu może zawierać jedynie cyfry',
               personalData: 'Dane osobowe',
               personalDataUpdateSuccess: 'Dane zostały zmienione.',
               profession: {
                  label: 'Zawód',
                  names: {
                     ADDICTION_PSYCHOTHERAPY_SPECIALIST: 'Specjalista psychoterapii uzależnień',
                     DIETITIAN: 'Dietetyk',
                     OTHER: 'Inny',
                     PSYCHOLOGIST: 'Psycholog',
                     PSYCHOTHERAPIST: 'Psychoterapeuta',
                  },
               },
            },
            tabsId: 'zakladki',
         },
         nfzLogin: {
            cancelChangePassword: 'Anuluj zmianę hasła',
            changeNFZPassword: 'Zmień hasło NFZ',
            changingNFZPassword: 'Zmiana hasła w NFZ',
            configureNfzIntegration: 'Skonfiguruj integrację NFZ',
            connectionWithNfzFailedLoginInformationIncorrect:
               'Połączenie z systemem NFZ nie powiodło się. Podane dane logowania są nieprawidłowe.',
            correctlyChangedPasswordInEwusApplication: 'Poprawnie zmieniono hasło w aplikacji eWUŚ.',
            enterMfaSecret: 'Wprowadź klucz bezpieczeństwa wygenerowany dla usług NFZ (eWUŚ/eZWM).',
            enterMfaTotp: 'Podaj kod z aplikacji do weryfikacji dwuetapowej.',
            errorWhileFetchingNfzConfiguration: 'Pobranie danych konfiguracji NFZ nie powiodło się.',
            failedToFetchEwusConfiguration: 'Nie powiodło się pobranie konfiguracji eWUŚ',
            failedToFetchEzwmConfiguration: 'Nie powiodło się pobranie konfiguracji eZWM',
            failedToFetchNfzConfiguration: 'Nie powiodło się pobranie konfiguracji NFZ',
            incorrectCurrentPasswordInEwus: 'Niepoprawne obecne hasło w eWUŚ.',
            loginCredentialsForNfzHaveBeenSaved: 'Zapisano dane logowania się do NFZ.',
            messageFromEWUS: 'Komunikat z systemu eWUŚ: {{message}}',
            mfaSecret: {
               label: 'Klucz bezpieczeństwa (sekret)',
               validation: {
                  invalidValue: 'Nieprawidłowa wartość',
               },
            },
            mfaStrategy: {
               information: {
                  helpCenter: 'Centrum pomocy',
                  text: 'Chcesz dowiedzieć się więcej na temat logowania dwuetapowego? Zajrzyj do <link />.',
               },
               label: 'Logowanie dwuetapowe (MFA z tokenem TOTP) poprzez',
               map: {
                  SECRET: 'Wgranie klucza bezpieczeństwa',
                  TOTP: 'Podawanie kodu podczas logowania',
               },
            },
            mfaTotp: {
               label: 'Kod hasła jednorazowego',
               validation: {
                  invalidValue: 'Kod musi składać się z sześciu cyfr.',
               },
            },
            newPassword: 'Nowe hasło',
            nfzAccountBlocked: 'Konto jest zablokowane w systemie NFZ. Spróbuj ponownie za 15 minut.',
            nfzIntegration: 'Integracja NFZ',
            nfzLogIn: 'Logowanie NFZ',
            nfzLogin: 'Login NFZ',
            nfzPassword: 'Hasło NFZ',
            nfzPasswordHasExpiredYouNeedToMakePasswordChange: 'Wygasło hasło do systemu NFZ, zmień hasło NFZ',
            noNfzConfigurationHeader: 'Brak konfiguracji integracji NFZ',
            noNfzConfigurationMessageForAdmin:
               'Nie skonfigurowano integracji NFZ. Uzupełnij wymagane dane, by móc zalogować się do NFZ.',
            noNfzConfigurationMessageForPersonnel:
               'Nie skonfigurowano integracji NFZ. Skontaktuj się z administratorem, by móc zalogować się do NFZ.',
            passwordIsNotDifferent: 'Nowe hasło nie może być takie samo jak stare',
            passwordNotMatchingRestrictions:
               'Nowe hasło musi składać się z co najmniej 8 znaków, zawierać małe i wielkie litery oraz cyfry i znaki specjalne.',
            passwordsAreDifferent: 'Podane hasła są różne',
            personnelCode: 'Kod personelu',
            repeatNewPassword: 'Powtórz nowe hasło',
            saveAndConnect: 'Zapisz i połącz',
            unknownErrorOccurredWhileChangingPasswordInEwusApplication:
               'Wystąpił nieznany błąd podczas zmiany hasła w aplikacji eWUŚ.',
         },
         overlappingAvailabilityError:
            'Podany zakres dostępności zachodzi na istniejącą dostępność w dniu {{conflictDate}}. Należy zmienić jej zakres.',
         plannedVisitsOccurring: 'Istnieją zaplanowane wizyty na tę dostępność',
         plannedVisitsOccurringOnDate: 'Istnieją zaplanowane wizyty na tę dostępność w dniu {{appointmentDate}}',
         practitionerSafePresenter: {
            noSpecialties: 'brak specjalizacji',
         },
         recurrencePeriod: 'Częstotliwość powtarzania',
         schedule: 'Harmonogram',
         sendToDocplanner: 'Wyślij do portalu Znany Lekarz',
         sendToPatientPortal: 'Wyślij do portalu drEryk Pacjent',
         specialist: 'Specjalista',
         specialtiesTable: {
            addSpecialty: 'Dodaj specjalizację',
            completionRequired: 'Wymagane uzupełnienie specjalizacji lub zaznaczenie “bez specjalizacji”.',
            // eslint-disable-next-line camelcase
            level_1: 'I stopnia',
            // eslint-disable-next-line camelcase
            level_2: 'II stopnia',
            medicalSpecialty: 'Kod i nazwa',
            noSpecialty: 'bez specjalizacji',
            pending: 'w trakcie',
            searchCodeOrName: 'Wyszukaj kod lub nazwę specjalizacji...',
            specialist: 'specjalista',
            specialty: 'Specjalizacja',
            specialtyAlreadyOnList: 'Specjalizacja jest już na liście.',
            specialtyLevel: 'Stopień',
         },
         successfullyCreatedAvailability: 'Nowa dostępność została dodana do harmonogramu.',
         successfullyRemovedAvailability: 'Dostępność została usunięta z harmonogramu.',
         successfullyUpdatedAvailability: 'Dane dostępności zostały zaktualizowane.',
         timeSlots: {
            fifteenMinutes: '15 minut',
            minutesAbbreviation: 'min',
            other: 'Inna wartość',
            tenMinutes: '10 minut',
            thirtyMinutes: '30 minut',
            twentyMinutes: '20 minut',
            withoutDivision: 'Bez podziału na wizyty',
         },
         toHour: 'do',
         updateRecurringWorkingTime: 'Edytuj cykliczny czas pracy',
         updateWorkingTime: 'Edytuj czas pracy',
         visitDuration: 'Czas trwania wizyty',
         visitEncounterMode: 'Typ wizyty',
      },
   },
};

export const personnelTranslationKeys = createScopedTranslationKeys(translations.pl, 'personnel');
export const timeSlotsTranslationKeys = personnelTranslationKeys.timeSlots;
export const personalDataTranslationKeys = personnelTranslationKeys.myAccount.personalData;
export const nfzLoginTranslationKeys = personnelTranslationKeys.nfzLogin;
export const mfaSettingsTranslationKeys = personnelTranslationKeys.myAccount.mfaSettings;
